import * as types from '../../actions/types';

export default (state = { isOpen: false, step: 'start', isp_other: '', submitting: false, step_history: [], data: {} }, action) => {
	switch(action.type) {
		case types.OPEN_FEEDBACK:
			return { ...state, isOpen: true };
		case types.CLOSE_FEEDBACK:
			return { ...state, isOpen: false };
		case types.SET_FEEDBACK_STEP:
			return { ...state, step: action.step, step_history: [...state.step_history, action.step] };
		case types.SET_FEEDBACK_LOCATION:
			return { ...state, location: action.location };
		case types.SET_FEEDBACK_ISP:
			return { ...state, isp: action.isp };
		case types.SET_FEEDBACK_ISP_OTHER:
			return { ...state, isp_other: action.isp_other };
		case types.SET_FEEDBACK_SUBMITTING:
			return { ...state, submitting: action.submitting };
		case types.CLEAR_FEEDBACK_LOCATION:
			return { ...state, location: { location: null, isps: state.location.isps } };
		case types.SET_FEEDBACK_SHARD:
			return { ...state, shard: action.shard };
		case types.SET_FEEDBACK_DATA:
			return { ...state, data: { ...state.data, ...action.data }};
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/store/reducers/feedback.js